import { getImageSrc, getLabelsByLanguage } from "../../../../utilites/util";
import { useSelector } from "react-redux";
import LogoutFromTnAccountContainer from "../../../../auth/LogoutFromTnAccount";
import React from "react";
import back from "../../../assets/images/arrows/backward.png";
import { HEADER_ITEM_IDS } from "../../../../constants/HeaderItemIds";

type Props = {
  item: any;
  hideSubmenu: () => {};
};

export const HeaderProfilePopupContent = ({ item, hideSubmenu }: Props) => {
  const user = useSelector((state: any) => state.session.user);
  const labels = getLabelsByLanguage();

  // format name
  let name = `${user?.firstName} ${user?.lastName}`;
  name = name.trim().length > 0 ? name : labels.welcome;
  // format email
  let email = user?.email;
  email = email?.trim().length > 0 ? email : '';

  const settingsItem = item.items.find((item: any) => item.id === HEADER_ITEM_IDS.SETTINGS);
  const logoutItem = item.items.find((item: any) => item.id === HEADER_ITEM_IDS.LOGOUT);

  return (
    <>
      <div className="yettel-profile-menu__header">
        <div className='text-start m-4 yettel-profile-menu__header__back-arrow' onClick={ () => {hideSubmenu(); }}>
          <img src={back} width={10} alt='back' />
          <span className="yettel-link pe-0 ps-2 yettel-font text-14">{labels.back}</span>
        </div>
        <div className="yettel-profile-menu__header__avatar">
          <img src={user.avatarUrl ?? getImageSrc("", 'no-profile-photo', 'png')} alt="avatar" className="yettel-profile-menu__avatar"/>
        </div>
      </div>
      <div className="yettel-profile-menu__body yettel-font">
        <p className="yettel-profile-menu__body__name ">
          {name}
        </p>
        <p className="yettel-profile-menu__body__email">
          {email}
        </p>
      </div>
      <div className="yettel-profile-menu__items yettel-font">
        <a href={settingsItem.url} className="yettel-profile-menu__items__settings yettel-link-no-underline">
          {settingsItem.title}
        </a>
        <span className="yettel-profile-menu__items__logout yettel-link-no-underline">
          <LogoutFromTnAccountContainer>
            <span>
              <img src={getImageSrc("", 'logout', 'png')} alt="logout"/>
              {logoutItem.title}
            </span>
          </LogoutFromTnAccountContainer>
        </span>
      </div>
    </>
  );
};

export default HeaderProfilePopupContent;
